<template>
  <a-select
    :loading="loadingList"
    allowClear
    show-search
    :filter-option="false"
    @search="onSearchSelect"
    @change="handleInput"
    v-bind="{
      ...selectProps,
      defaultValue: selectProps.defaultValue
        ? selectProps.defaultValue
        : undefined,
    }"
  >
    <a-spin v-if="loadingList" slot="notFoundContent" size="small" />
    <a-select-option
      v-if="!loadingList && datas.length > 0"
      disabled
      key="disabled"
    >
      Enter to search
    </a-select-option>
    <a-select-option v-for="item in datas" :key="item.id">
      {{ item.code }} - {{ item.title }}
    </a-select-option>
  </a-select>
</template>
<script>
import query from "./constant/query";
import debounce from "lodash/debounce";
export default {
  props: {
    selectProps: {
      type: Object,
      default() {
        return {};
      },
    },
    isGetDataCreated: {
      type: Boolean,
      default: true,
    },
    initialDatas: {
      type: Array,
      default() {
        return [];
      },
    },
    variablesQuery: {
      type: Object,
      default() {
        return {};
      },
    },
    setValueResults: {
      type: Function,
      default() {
        return {};
      },
    },
    nameQueryItem: {
      type: String,
    },
  },
  data() {
    this.onSearchSelect = debounce(this.onSearchSelect, 500);
    return {
      loadingList: false,
      datas: [],
      filter: {},
    };
  },
  model: {
    event: "change",
  },

  methods: {
    handleInput(value) {
      this.$emit("change", value);
      if (value && Array.isArray(value) && value.length > 0) {
        let array = [];
        for (let i in value) {
          const find = this.datas.find((e) => e.id === value[i]);
          array.push(find);
        }
        this.setValueResults(array);
      } else {
        this.setValueResults(this.datas.find((e) => e.id === value));
      }
    },
    onSearchSelect(input, option) {
      this.datas = [];
      this.$set(this.filter, "query", input);
      this.onGetAllWorkShift();
    },
    onGetAllWorkShift() {
      this.loadingList = true;
      this.$apollo
        .query({
          query: this.nameQueryItem
            ? query[this.nameQueryItem]
            : query.getAllWorkShift,
          fetchPolicy: "no-cache",
          variables: {
            query: this.filter.query,
            limit: 20,
            page: 1,
            ...this.variablesQuery,
          },
        })
        .then(({ data }) => {
          if (data?.getAllWorkShift?.length >= 0) {
            if (this.initialDatas?.length > 0) {
              const uniqueInitialDatas = [];
              for (let i in this.initialDatas) {
                const item = this.initialDatas[i];
                const find = data.getAllWorkShift.find((e) => e.id === item.id);
                if (!find) {
                  uniqueInitialDatas.push(item);
                }
              }
              this.datas = [...data.getAllWorkShift, ...uniqueInitialDatas];
            } else {
              this.datas = [...data.getAllWorkShift];
            }
            this.loadingList = false;
          }
        })
        .catch((error) => {
          console.error("Error get list", error);
        });
    },
  },
  created() {
    if (this.initialDatas?.length > 0) {
      this.datas = [...this.initialDatas];
    } else {
      this.onGetAllWorkShift();
    }
  },
};
</script>
